<script setup>
defineProps({
  variant: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  title: { type: String, default: '' },
})

defineEmits(['click'])
</script>

<template>
  <button
    type="button"
    :class="['btn-icon', { danger: variant === 'danger' }]"
    :disabled="disabled"
    :title="title"
    :aria-label="title || undefined"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>
